export default __webpack_public_path__ + "static/media/default_project_logo.b82c50d1.svg";